import { useTranslation } from 'react-i18next';
import cslx from 'clsx';
import { OrderStatus as OrderStatusType } from '@/types';

interface OrderStatusProps {
  status: OrderStatusType;
}

const propsByStatus: {
  [key in OrderStatusType]: {
    styles: string;
    percent: number;
  };
} = {
  CANCELLED: {
    styles: 'bg-secondary-red text-primary-red',
    percent: 0,
  },
  PENDING: {
    styles: 'bg-secondary-yellow text-[#B54708]',
    percent: 33,
  },
  CONFIRMED: {
    styles: 'bg-secondary-blue text-primary-blue',
    percent: 66,
  },
  COMPLETE: {
    styles: 'bg-secondary-green text-primary-green',
    percent: 100,
  },
};

export default function OrderStatus(props: OrderStatusProps) {
  const { status } = props;
  const { t } = useTranslation();

  return (
    <div className="mb-4-0 w-2/5">
      <p className="font-bd mb-1-0">{t('orders.table_columns.status')}</p>
      <div
        className={cslx(
          propsByStatus[status].styles,
          'rounded-8-0 p-1-6 mb-1-6 shadow-lg',
        )}
      >
        <p className="font-bd">
          {t(`order.status.${status.toLowerCase()}` as any)}
        </p>
        <p></p>
      </div>
      <div className="">
        <div className="rounded-8-0 bg-secondary-green h-1-0 overflow-hidden relative">
          <div
            className="bg-[#33BA27] h-full rounded-r-8-0"
            style={{ width: `${propsByStatus[status].percent}%` }}
          ></div>
        </div>

        <div className="grid grid-cols-3 text-center font-li">
          <p
            className={cslx(status === OrderStatusType.Cancelled && 'font-bd')}
          >
            {t('order.status.canceled')}
          </p>
          <p className={cslx(status === OrderStatusType.Pending && 'font-bd')}>
            {t('order.status.pending')}
          </p>
          <p
            className={cslx(status === OrderStatusType.Confirmed && 'font-bd')}
          >
            {t('order.status.confirmed')}
          </p>
          <p className={cslx(status === OrderStatusType.Complete && 'font-bd')}>
            {t('order.status.complete')}
          </p>
        </div>
      </div>
    </div>
  );
}
